import { render, staticRenderFns } from "./AccountDetailsBar.vue?vue&type=template&id=3a45596e&"
import script from "./AccountDetailsBar.vue?vue&type=script&lang=ts&"
export * from "./AccountDetailsBar.vue?vue&type=script&lang=ts&"
import style0 from "./AccountDetailsBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports